import type { PepDictionary } from "../types";

export const fr: PepDictionary = {
  "nav.products": "Produits",
  "nav.solutions": "Solutions",
  "nav.industries": "Secteurs",
  "nav.package": "Configurer",
  "nav.why": "Pourquoi ITaaS",
  "nav.docs": "Documentation",
  "nav.knowledge": "Connaissances",
  "nav.marketplace": "Marketplace",
  "nav.partners": "Partenaires",
  "nav.affiliation": "Affiliation",
  "nav.about": "À propos",
  "nav.contact": "Contact",
  "nav.search": "Recherche",
  "nav.searchPlaceholder": "Rechercher…",
  "nav.login": "Connexion",
  "nav.trial": "Essai gratuit",
  "nav.compose": "Composer ma solution",
  "nav.demo": "Demander une démo",
  "nav.toggleTheme": "Basculer le thème",
  "nav.menu": "Menu",
  "nav.more": "Plus",
  "footer.tagline":
    "Plateforme logicielle métier d’ITaaS RDC — éducation, RH, opérations, finance et industrie.",
  "footer.products": "Produits",
  "footer.catalog": "Catalogue",
  "footer.marketplace": "Marketplace",
  "footer.solutions": "Solutions",
  "footer.industries": "Secteurs",
  "footer.resources": "Ressources",
  "footer.documentation": "Documentation",
  "footer.knowledge": "Centre de connaissances",
  "footer.package": "Configurer votre solution",
  "footer.why": "Pourquoi ITaaS",
  "footer.rights": "© {year} ITaaS RDC. Tous droits réservés.",
  "footer.license": "Logiciels commerciaux — licences et abonnements.",
  "common.loading": "Chargement…",
  "common.learnMore": "En savoir plus →",
  "common.contactSales": "Contacter les ventes",
  "common.requestDemo": "Demander une démo",
  "common.freeTrial": "Essai gratuit",
  "common.back": "Retour",
  "common.accept": "Accepter",
  "common.decline": "Refuser",
  "home.seo.title": "ITaaS Suite | Plateforme logicielle métier en RDC",
  "home.seo.description":
    "Plateforme logicielle métier intégrée pour l’éducation, les ressources humaines, la finance, les stocks, les opérations et l’industrie — éditée et accompagnée par ITaaS RDC à Lubumbashi.",
  "home.kicker": "ITaaS Suite · par ITaaS RDC",
  "home.title": "ITaaS Suite | Plateforme logicielle métier en RDC",
  "home.subtitle":
    "Une suite intégrée pour piloter l’éducation, les ressources humaines, les opérations, la finance et l’industrie — conçue et accompagnée depuis Lubumbashi.",
  "home.cta.trial": "Demander une démonstration",
  "home.cta.products": "Découvrir les solutions",
  "home.pillars.africa": "Ancrée à Lubumbashi",
  "home.pillars.africa.text":
    "Éditeur et accompagnement ITaaS RDC pour les organisations professionnelles en RDC.",
  "home.pillars.modular": "Adoption modulaire",
  "home.pillars.modular.text":
    "Activez les produits dont vous avez besoin, progressivement.",
  "home.pillars.identity": "Une suite cohérente",
  "home.pillars.identity.text":
    "Applications métier sur une plateforme commune — identité, données, intégration.",
  "home.pillars.verticals": "Métiers couverts",
  "home.pillars.verticals.text":
    "Éducation, capital humain, opérations, finance, industrie et mines.",
  "home.stats.modules": "modules",
  "home.stats.ga": "disponibles",
  "home.stats.verticals": "verticals",
  "home.catalog.title": "Solutions",
  "home.catalog.subtitle": "Découvrez les solutions publiées de la suite ITaaS",
  "home.regions.title": "Présence",
  "home.ctaBand.title": "Construisons la solution adaptée à votre organisation.",
  "home.ctaBand.text": "Demandez une démonstration ou contactez ITaaS RDC à Lubumbashi.",
  "products.seo.title": "Catalogue produits ITaaS",
  "products.seo.description":
    "ERP, RH, stock, Hospitol, Edu, MinePortal, sécurité, transit — logiciels modulaires pour la RDC et l'Afrique. Essai gratuit 30 jours.",
  "products.kicker": "Suite modulaire · RDC & Afrique francophone",
  "products.title": "Le logiciel qui s'adapte à votre métier, pas l'inverse",
  "products.subtitle":
    "École, hôpital, mine, PME ou ONG — composez uniquement les modules dont vous avez besoin. Une identité, une facturation, un support local.",
  "products.searchPlaceholder": "Rechercher : école, mine, pharmacie, RH…",
  "products.cta.trial": "Essai gratuit 30 jours",
  "products.cta.solutions": "Voir les solutions",
  "products.cta.industries": "Par secteur d'activité",
  "products.stats.products": "Produits",
  "products.stats.available": "Disponibles",
  "products.stats.verticals": "Verticales",
  "products.stats.sectors": "Secteurs",
  "products.stats.footnote": "Logiciels commerciaux · USD & CDF · Déploiement accompagné",
  "products.spotlight.title": "Solutions métier phares",
  "products.spotlight.subtitle": "Des verticales complètes, composées sur la plateforme ITaaS",
  "products.sectors.title": "Par où commencer ?",
  "products.catalog.title": "Tous les modules",
  "products.catalog.subtitle": "Filtrez par catégorie ou recherchez un produit précis",
  "products.filter.all": "Tous",
  "products.empty": "Aucun produit ne correspond à votre recherche.",
  "products.ctaBand.title": "Vous ne savez pas par où commencer ?",
  "products.ctaBand.text":
    "Nos experts vous orientent vers le bon package — essai gratuit, démo ou devis personnalisé.",
  "search.title": "Recherche",
  "search.placeholder": "ERP, mine, pharmacie, API…",
  "search.submit": "Rechercher",
  "search.loading": "Recherche en cours…",
  "search.noResults": "Aucun résultat pour « {query} ».",
  "search.type.product": "Produit",
  "search.type.solution": "Solution",
  "search.type.industry": "Secteur",
  "search.type.doc": "Documentation",
  "search.type.marketplace": "Marketplace",
  "search.type.partner": "Partenaire",
  "analytics.consent.title": "Mesure d'audience",
  "analytics.consent.text":
    "Nous utilisons des statistiques anonymes (pages vues, sans cookies tiers) pour améliorer le site. Aucune donnée personnelle n'est vendue.",
  "analytics.consent.accept": "Accepter",
  "analytics.consent.decline": "Refuser",
};
